import { render } from "./stars-rate-svg.vue?vue&type=template&id=54121c20"
import script from "./stars-rate-svg.vue?vue&type=script&lang=js"
export * from "./stars-rate-svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__